module.exports = __webpack_public_path__ + "static/media/Website.3296f705.svg";